import React from 'react';
import moment from "moment/moment";
import axios from "axios";
import {handleError} from "../../HandleError";
import {connect} from "formik";
import {ImSpinner6} from "react-icons/im";
import {FaPause} from "react-icons/fa";
import {IoIosWarning} from "react-icons/io";
import NoDataIndicator from "../../NoDataIndicator";
import {UncontrolledTooltip} from 'reactstrap';
import Question from "../../../assets/images/icons/question-circle-svgrepo-com.svg";
import Delete from "../../../assets/images/icons/trash-full-svgrepo-com (2).svg";
import Download from "../../../assets/images/icons/download-svgrepo-com.svg";
import localized from '../../../i18n';
import dashboardicon from "../../../assets/images/icons/dashboardicon.svg";
import {ReactSVG} from "react-svg";

const fileStatus = {
    1: "waiting",
    2: "initialization",
    3: "wait_on_queue",
    4: "working",
    5: "paused",
    6: "canceled",
    7: "finished"
}

const DashboardTableBody = (props) => {
    const {recentStocks, isLoadingStocks, toggleDeleteModel} = props;

    const downloadFile = (type, item) => {
        const data = {file_id: item.file_id || null, type: type};
        axios.post(`/api/download`, data)
            .then((response) => {
                const blob = new Blob([response.data], {type: 'text/csv;charset=utf-8'});
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute('download', item.file_name);
                a.click()
            })
            .catch((err) => {
                handleError(err);
            })
    }

    const toolkit_status = {
        1: localized.toolkit_status_1,
        2: localized.toolkit_status_2,
        3: localized.toolkit_status_3,
        4: localized.toolkit_status_4,
        5: localized.toolkit_status_5,
        6: localized.toolkit_status_6,
        7: localized.toolkit_status_7,
    }

    if (recentStocks.total === 0 && !isLoadingStocks) {
        return <NoDataIndicator/>
    }
    return (
        <>
            {(recentStocks.data || []).map((item, index) => {
                const status = fileStatus[item.status];
                return (
                    <tr key={index}>
                        <td>{index + recentStocks.from}</td>
                        <td>{item.file_name || ""}</td>
                        <td>{item.start_date ? moment(item.start_date).format("ll") : ""}</td>
                        <td>{item.start_date ? moment(item.start_date).format("hh:mm:ss") : ""}</td>
                        <td>{item.end_date ? moment(item.end_date).format("hh:mm:ss") : "-"}</td>
                        <td>{item.total_email ? item.total_email : "0"}</td>
                        {/*<td>{item.processed_email ? item.processed_email : "0"}</td>*/}
                        <td>
                            <div>
                                <div className="delete-icon">
                                    {item.valid || 0}
                                </div>
                                {/*<div className={`download-icon ${!item.valid && "invisible"}`} onClick={() => downloadFile("valid",item)}>*/}
                                {/*    <img src={Download} style={{height:"25px",marginBottom:"6px"}} alt={"downloadLogo"}/>*/}
                                {/*</div>*/}
                            </div>
                        </td>
                        {/*<td>{item.invalid ? item.invalid : "0"}</td>*/}
                        <td className="status_content">
                            <div className="d-flex align-content-center justify-content-center">
                              <span className={`status ${status}`}>
                                   {(status === "finished") ? (
                                           <div
                                               className={`download-icon ${status !== "finished" && "invisible"} d-flex align-items-center`} onClick={() => downloadFile("all", item)}>
                                               Download
                                               <img src={Download} height="16px" alt={"deleteLogo"}/>
                                           </div>
                                       ) :
                                       (
                                           <>
                                               {status.toString().replaceAll("_", " ")}
                                               {(status === "waiting" || status === "initialization" || status === "wait_on_queue" || status === "working") && <ImSpinner6 className="importing-spinner"/>}
                                               {status === "paused" && <FaPause className="completed-spinner"/>}
                                               {status === "canceled" && <IoIosWarning className="failed-spinner"/>}
                                           </>
                                       )}



                              </span>
                                <span id={`status_${item.id}`} className="question_icon">
                                  <img src={Question} height="18px" alt={"QuestionLogo"}/>
                                  <UncontrolledTooltip
                                      target={`status_${item.id}`}
                                      placement="top"
                                  > {toolkit_status[item.status]}
                                    </UncontrolledTooltip>
                              </span>
                            </div>
                        </td>
                        <td>
                            <div className={"table-action"}>
                                <div className="delete-icon" onClick={() => toggleDeleteModel(item.id)}>
                                    <img src={Delete} height="25px" alt={"deleteLogo"}/>
                                </div>
                                {/*<div className={`download-icon ${status !== "finished" && "invisible"}`}*/}
                                {/*     onClick={() => downloadFile("all", item)}>*/}
                                {/*    <img src={Download} style={{height: "25px", marginBottom: "6px"}}*/}
                                {/*         alt={"downloadLogo"}/>*/}
                                {/*</div>*/}
                            </div>
                        </td>
                    </tr>
                )
            })}
        </>
    );
};

export default connect(DashboardTableBody);